(function () {
  'use strict';

  angular
    .module('crewHotacReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewHotacReport', {
        url: '/crew-hotac-report',
        views:{
          'crewHotacReportView':{
            templateUrl: 'crew-hotac-report/views/crew-hotac-report.tpl.html',
            controller: 'CrewHotacReportCtrl',
            controllerAs: 'crewHotacReport'
          }
        }
      });
  }
}());
